
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/om-itdagene",
      function () {
        return require("private-next-pages/om-itdagene.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/om-itdagene"])
      });
    }
  